//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'OttawaKneeRule',
  data() {
    return {
      form: {
        age: '0',
        patella: '0',
        weight: '0',
        fibula: '0',
        flex: '0',
      },
      hasScore: false,
      disabled: false,
      defaultJson: {
        "Tenderness at fibular head": "腓骨头压痛",
        "Knee imaging required": "需要膝关节摄片",
        "Imaging is not indicated": "无需影像学检查",
        "Inability to flex knee to 90°": "无法屈膝至 90°",
        "Inability to bear weight both immediately and in ED": "受伤即刻和急诊就诊时均无法负重",
        "Isolated patella tenderness (no other bony tenderness)": "孤立性髌骨压痛（无其他骨压痛）",
        "Age ≥ 55 years": "年龄 ≥ 55 岁"
      },
      paininmalleolarorfoot: 0,
      footimagingrequired: 0,
      ankleimagingrequired: 0
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key] = 0
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      // age + patella + fibula + flex + weight
      let result = form.age + form.patella + form.fibula + form.flex + form.weight
      self.hasScore = true
      return String(result)
    },
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/OttawaKneeRule.vue